module.exports = __webpack_public_path__ + "img/infrasel_6.995abaa9.png";